// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.support.RentalManagerUserSupportWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type {
  GetHelpTopicListResponseV2Dto,
  RentalManagerSupportHelpArticlesResponseDto,
  RentalManagerUserSupportRequestV1Dto,
} from '../..';

interface GetHelpArticlesParams {
  category?: string;
  topic?: string;
}

export const RentalManagerUserSupportWebApiHandler_getHelpArticles_Path = '/api/web/v1/users/support/getHelpArticles';

/**
 * Get help articles
 */
export const RentalManagerUserSupportWebApiHandler_getHelpArticles = (
  getParams: GetHelpArticlesParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetHelpArticlesParams, never, RentalManagerSupportHelpArticlesResponseDto>({
    getParams: getParams,
    endpoint: RentalManagerUserSupportWebApiHandler_getHelpArticles_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserSupportWebApiHandler_getHelpTopics_Path = '/api/web/v1/users/support/getHelpTopics';

/**
 * Get help topics with categories and outages
 */
export const RentalManagerUserSupportWebApiHandler_getHelpTopics = (environment?: RentalManagerEnvironment) => {
  return frontEndRequestV2<never, never, GetHelpTopicListResponseV2Dto>({
    endpoint: RentalManagerUserSupportWebApiHandler_getHelpTopics_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserSupportWebApiHandler_submitRequest_Path = '/api/web/v1/users/support/submitRequest';

/**
 * Submit a support request
 */
export const RentalManagerUserSupportWebApiHandler_submitRequest = (
  postData: RentalManagerUserSupportRequestV1Dto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, RentalManagerUserSupportRequestV1Dto, string>({
    endpoint: RentalManagerUserSupportWebApiHandler_submitRequest_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};
